import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Breadcrumbs,
  Grid,
  Typography,
 
} from "@mui/material";
import MuiLink from "@mui/material/Link";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../layout/Layout";
import { config, weeklyPlanAPI } from "../../config";
import axios from "axios";
import { startOfWeek } from "date-fns";
import { useSearchParams } from "react-router-dom";
import WeeklyPlanAccordion from "./WeeklyPlanAccordion";

function WeeklyPlanScheduleView() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [searchParams] = useSearchParams(); // 👈 Get query params
  // Extract query params
  const queryFromDate = searchParams.get("from");
  const queryToDate = searchParams.get("to");

  const parsedFromDate = queryFromDate
    ? new Date(queryFromDate)
    : startOfWeek(new Date(), { weekStartsOn: 1 });
  const parsedToDate = queryToDate ? new Date(queryToDate) : new Date();

  const [fromDate, setFromDate] = useState(parsedFromDate);
  const [toDate, setToDate] = useState(parsedToDate);

  const [weeklyPlan, setWeeklyPlan] = useState("");

  const getWeeklyReport = () => {
    const data = {
      employee_id: id,
      fromDate,
      toDate,
      intType: 7,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = weeklyPlanAPI;

    axios(config)
      .then(function (response) {
        setWeeklyPlan(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getWeeklyReport();
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      getWeeklyReport();
    }
  }, [id]);

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3} sx={{ mb: 5 }}>
          <Grid item xs={12}>
            <Typography className="page_title" textAlign="left" gutterBottom>
              Weekly Payment Report
            </Typography>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Breadcrumbs aria-label="breadcrumb">
                  <MuiLink underline="hover" color="inherit" href="/dashboard">
                    Dashboard
                  </MuiLink>
                  <Typography color="text.primary">Reports</Typography>
                </Breadcrumbs>
              </Grid>

              <Grid item>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(-1)}
                  startIcon={<ArrowBackIosIcon />}
                >
                  Back
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Add content below with some spacing */}
        <Grid>
          {weeklyPlan && weeklyPlan.length > 0 ? (
            <WeeklyPlanAccordion weeklyPlan={weeklyPlan} />
          ) : (
            <Typography>No data found for the selected date range.</Typography>
          )}
        </Grid>
      </Grid>
    </Layout>
  );
}
export default WeeklyPlanScheduleView;
